export default {
  type: 'in_place',
  instanceName: 'registrar/zero/passwordSetup',
  modalClassName: 'modal-password-form',

  fields: {
    login: { type: 'text' },
    password: { type: 'text' },
    password2: { type: 'text' },
    branch: { type: 'select' },
    region: { type: 'select' },
  }
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/forms/passwordFormConfig.js